//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { api_WorldCupCompetitions, api_WorldCupMatches } from "@/api";
import { getWorldCupTeamName } from "@/utils/worldCupTeams";

export default {
  data() {
    return {
      loading: false,
      query: {
        competitionCode: "",
        season: 0,
        status: "",
        current: 1,
        size: 100,
      },
      competitions: [],
      matches: [],
    };
  },
  created() {
    this.getCompetitions();
    this.getMatches();
  },
  methods: {
    getPayload(res) {
      return (res && res.data && (res.data.data || res.data.Data)) || {};
    },
    getCompetitions() {
      api_WorldCupCompetitions().then((res) => {
        const data = this.getPayload(res);
        this.competitions = (data.list || [])
          .map((item) => ({
            code: item.code || item.Code,
            name: item.name || item.Name,
            season: item.season || item.Season || 0,
          }))
          .filter((item) => item.code !== "WC");
      });
    },
    getMatches() {
      this.loading = true;
      api_WorldCupMatches(this.query)
        .then((res) => {
          const data = this.getPayload(res);
          this.matches = data.list || [];
        })
        .finally(() => {
          this.loading = false;
        });
    },
    setStatus(status) {
      this.query.status = status;
      this.getMatches();
    },
    setCompetition(code) {
      const competition = this.competitions.find((item) => item.code === code);
      this.query.competitionCode = code;
      this.query.season = competition ? competition.season : 0;
      this.query.current = 1;
      this.getMatches();
    },
    winDrawLose(match) {
      return (match.markets || match.Markets || []).filter((item) => item.marketType === "WinDrawLose");
    },
    teamName(competitionCode, code, name) {
      return getWorldCupTeamName(code, name, competitionCode);
    },
    formatDate(value) {
      if (!value) return "-";
      const date = new Date(value);
      const pad = (num) => String(num).padStart(2, "0");
      return `${date.getMonth() + 1}-${pad(date.getDate())} ${pad(date.getHours())}:${pad(date.getMinutes())}`;
    },
    formatOdds(value) {
      const num = Number(value || 0);
      return num > 0 ? num.toFixed(2) : "--";
    },
    competitionName(code) {
      const competition = this.competitions.find((item) => item.code === code);
      return (competition && competition.name) || code || "";
    },
    getStatusName(status) {
      const names = {
        Scheduled: "未开赛",
        InPlay: "进行中",
        Finished: "已结束",
        Cancelled: "已取消",
        Postponed: "延期",
      };
      return names[status] || status || "-";
    },
    goDetail(id) {
      this.$router.push({ name: "worldcupDetail", params: { id } });
    },
    hideBrokenImage(event) {
      event.target.style.display = "none";
    },
  },
};
